import { cn } from '@/lib/utils';
import { Button, type ButtonProps } from './Button';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    variant?: ButtonProps['variant'];
  };
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-16 text-center',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-surface-subtle text-subtle">
          {icon}
        </div>
      )}
      <h3 className="text-[13px] font-semibold text-text">{title}</h3>
      {description && (
        <p className="mt-1 max-w-xs text-[13px] text-subtle leading-relaxed">{description}</p>
      )}
      {action && (
        <div className="mt-5">
          <Button
            variant={action.variant || 'primary'}
            size="sm"
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
}
